/**
 * The site-wide top bar: Trace logo (→ trace3d.app), a switcher across the
 * tools, and an "Open Studio" link. Shared by the landing page and every tool
 * so moving between tools is one click from anywhere.
 */
export type ToolId = 'home' | 'model' | 'video' | 'image';

/** The tools, in the order they appear in the nav and on the landing page. */
export const TOOLS: ReadonlyArray<{ id: Exclude<ToolId, 'home'>; href: string; nav: string }> = [
  { id: 'model', href: '/model.html', nav: '3D model' },
  { id: 'video', href: '/video.html', nav: 'Video' },
  { id: 'image', href: '/image.html', nav: 'Image marker' },
];

export function renderTopBar(current: ToolId): string {
  const links = TOOLS.map(t =>
    `<a href="${t.href}"${t.id === current ? ' aria-current="page"' : ''}>${t.nav}</a>`,
  ).join('');
  return `
    <header class="top-bar">
      <a class="top-bar-logo" href="/" title="Creator Tools home">
        <img src="/trace_logo.png" alt="Trace Creator Tools" />
      </a>
      <nav class="tool-nav" aria-label="Tools">${links}</nav>
      <a class="top-bar-cta" href="https://studio.trace3d.app">Open Studio</a>
    </header>
  `;
}
